
export default {
  data() {
    return {
      currentSlide: 1,
      activeIndex: 0,

      // Swipe state
      swipeStartX: 0,
      swipeCurrentX: 0,
      isSwiping: false,
      swipeThreshold: 50,

      autoplayInterval: null,
      autoplayDelay: 7000,
      isAutoplayPaused: false,
      swiperSlides: [
        {
          image: '/images/top/carousel/ai-day-2026.jpg',
          cat: 'PICK UP',
          title: 'DeNAはAIに<br/>オールイン',
          description:
            'DeNAは、組織と人のダイナミズムを生み出すエコシステムとなり、AIの波を捉え、そして波を起こす存在になっていきます。',
          listType: 'column',
          buttons: [
            {
              name: 'web',
              title: 'DeNA x AI Day 2026',
              link: '/ai-day-2026/'
            }
          ]
        },
        {
          image: '/images/top/carousel/slide1.jpg',
          cat: 'PICK UP',
          title: 'For & With Startups',
          description:
            'DeNAは、AIの大波を捉えるために、全社をあげてAI活用と新しい事業の立ち上げに取り組んでいます。 \n資金調達、Go to Market、自社に最適なAIツール、グローバルチームとの連携、アクセラレータープログラムなどに興味をお持ちの方にイベントの情報の提供を行なっております',
          listType: 'column',
          buttons: [
            {
              name: 'more',
              title: '詳細はこちら',
              link: 'https://dena.ai/news/dena-ver2-ai-for-and-with-startups/'
            }
          ]
        },
        {
          image: '/images/top/carousel/slide2.jpg',
          cat: 'PICK UP',
          title: '南場が語るこれからの「人と組織とAI」のあり方',
          description:
            'DeNAが全社で挑むAIネイティブカンパニーへの変革と、イノベーションを生み出す組織について（HR SUCCESS SUMMIT 2025）',
          listType: 'column',
          buttons: [
            {
              name: 'more',
              title: 'フルスイング',
              link: 'https://fullswing.dena.com/archives/100169/'
            },
            {
              name: 'youtube',
              title: 'Youtube',
              link: 'https://youtu.be/LNd2Cif-55M?si=p_HFRYBagz0bxWOc'
            }
          ]
        }
      ]
    }
  },
  computed: {
    totalSlides() {
      return this.swiperSlides.length
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsapContext(() => {
        this.initAutoScroll()
      })
      this.startAutoplay()
    })
  },
  beforeDestroy() {
    this.stopAutoplay()
  },
  methods: {
    slidePrev() {
      this.pauseAutoplay()
      let next = this.activeIndex - 1
      if (next < 0) {
        next = this.totalSlides - 1
      }
      this.activeIndex = next
      this.currentSlide = this.activeIndex + 1
      this.resumeAutoplay()
    },
    slideNext() {
      this.pauseAutoplay()
      let next = this.activeIndex + 1
      if (next > this.totalSlides - 1) {
        next = 0
      }
      this.activeIndex = next
      this.currentSlide = this.activeIndex + 1
      this.resumeAutoplay()
    },

    initAutoScroll() {
      // Start auto-scrolling for all text elements every 3 seconds
      this.swiperSlides.forEach((item, slideIndex) => {
        if (item.listType === 'column') {
          item.buttons.forEach((icon) => {
            const refName = `iconText_${slideIndex}_${icon.name}`
            this.scrollText(refName)
          })
        }
      })
    },
    scrollText(refName) {
      const element = this.$refs[refName]?.[0] || this.$refs[refName]
      if (element && element.scrollWidth > element.clientWidth) {
        const scrollDistance = element.scrollWidth - element.clientWidth + 10

        // Create a timeline for the scroll animation
        const tl = this.$gsap.timeline({ repeat: -1 })

        // Start from left (startp osition)
        this.$gsap.set(element, { scrollTo: { x: 0 } })

        // Scroll from left to right
        tl.to(element, {
          scrollTo: { x: scrollDistance },
          duration: 2,
          delay: 1,
          ease: 'ease'
        })
          // Wait 1 second
          .to(element, {
            duration: 1.5
          })
          // Scroll to the start of left
          .to(element, {
            scrollTo: { x: 0 },
            duration: 0,
            ease: 'none'
          })
      }
    },
    stopAutoScroll(refName) {
      const element = this.$refs[refName]?.[0] || this.$refs[refName]
      if (element) {
        this.$gsap.killTweensOf(element)
        element.scrollLeft = 0
      }
    },
    startAutoplay() {
      this.stopAutoplay()
      this.autoplayInterval = setInterval(() => {
        if (!this.isAutoplayPaused) {
          this.slideNext()
        }
      }, this.autoplayDelay)
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
        this.autoplayInterval = null
      }
    },
    pauseAutoplay() {
      this.isAutoplayPaused = true
    },
    resumeAutoplay() {
      this.isAutoplayPaused = false
      this.startAutoplay()
    },
    onTouchStart(e) {
      // Pause autoplay while interacting
      this.pauseAutoplay()
      this.isSwiping = true
      const touch = e.touches && e.touches[0] ? e.touches[0] : null
      this.swipeStartX = touch ? touch.clientX : 0
      this.swipeCurrentX = this.swipeStartX
    },
    onTouchMove(e) {
      if (!this.isSwiping) {
        return
      }
      const touch = e.touches && e.touches[0] ? e.touches[0] : null
      if (!touch) {
        return
      }
      this.swipeCurrentX = touch.clientX
    },
    onTouchEnd() {
      if (!this.isSwiping) {
        return
      }
      const delta = this.swipeCurrentX - this.swipeStartX
      if (Math.abs(delta) > this.swipeThreshold) {
        if (delta < 0) {
          this.slideNext()
        } else {
          this.slidePrev()
        }
      }
      this.isSwiping = false
      this.resumeAutoplay()
    },
    onMouseDown(e) {
      this.pauseAutoplay()
      this.isSwiping = true
      this.swipeStartX = e.clientX
      this.swipeCurrentX = e.clientX
    },
    onMouseMove(e) {
      if (!this.isSwiping) {
        return
      }
      this.swipeCurrentX = e.clientX
    },
    onMouseUp(e) {
      if (!this.isSwiping) {
        return
      }
      this.swipeCurrentX = e.clientX
      const delta = this.swipeCurrentX - this.swipeStartX
      if (Math.abs(delta) > this.swipeThreshold) {
        if (delta < 0) {
          this.slideNext()
        } else {
          this.slidePrev()
        }
      }
      this.isSwiping = false
      this.resumeAutoplay()
    },
    onMouseLeave() {
      if (!this.isSwiping) {
        return
      }
      const delta = this.swipeCurrentX - this.swipeStartX
      if (Math.abs(delta) > this.swipeThreshold) {
        if (delta < 0) {
          this.slideNext()
        } else {
          this.slidePrev()
        }
      }
      this.isSwiping = false
      this.resumeAutoplay()
    }
  }
}
